/**
 * Important: use a globalThis symbol to avoid any sort of clash. This creates a unique reference.
 */
const serverSym = Symbol.for('__ACCESS_SERVER_CONFIG__');
const clientSym = Symbol.for('__ACCESS_CLIENT_CONFIG__');
if (typeof window === 'undefined') {
	const serverConfig: Record<string, string> = {};
	const clientConfig: Record<string, string> = {};

	for (const [key, val] of Object.entries(process.env)) {
		const normalizedValue = val === 'true' || val === 'false' ? JSON.parse(val) : val!;

		if (key.startsWith('ACCESS_SERVER_')) {
			serverConfig[key.replace(/^ACCESS_SERVER_/, '')] = normalizedValue;
		} else if (key.startsWith('ACCESS_CLIENT_')) {
			clientConfig[key.replace(/^ACCESS_CLIENT_/, '')] = normalizedValue;
		} else if (key.startsWith('ACCESS_')) {
			serverConfig[key.replace(/^ACCESS_/, '')] = normalizedValue;
			clientConfig[key.replace(/^ACCESS_/, '')] = normalizedValue;
		}
	}
	// @ts-expect-error TS still doesn't let you declare a symbol as an index
	globalThis[serverSym] = serverConfig;
	// @ts-expect-error TS still doesn't let you declare a symbol as an index
	globalThis[clientSym] = clientConfig;
}

type Config = {
	API_URL: string;
	BASE_URL: string;
	BETTERSTACK_ENABLED: boolean;
	BETTERSTACK_TOKEN: string;
	CDN: string;
	CONTENTFUL_SPACEID: string;
	CONTENTFUL_API_KEY: string;
	CONTENTFUL_API_PREVIEW_KEY?: string;
	COOKIE_YES_ID: string;
	DOWN_FOR_MAINTENANCE: boolean;
	FORMSPREE_PROJECT_ID: string;
	GOOGLE_ACTIONS_ENDPOINT: string;
	GOOGLE_ACTIONS_PARTNER_ID: string;
	HOST: string;
	IMAGE_HOST: string;
	LOG_LEVEL?: string;
	MAP_HOST: string;
	MAPBOX_ACCESS_TOKEN: string;
	PIXEL_META: string;
	PIXEL_GTAG: string;
	PIXEL_GTM: string;
	POSTHOG_ENABLED: boolean;
	POSTHOG_WRITE_KEY: string;
	POSTHOG_API_KEY?: string;
	POSTHOG_ENABLE_SESSION_RECORDINGS?: boolean;
	SHOP_STORE_URL: string;
	SENTRY_DSN: string;
	SENTRY_ENABLED: boolean;
	SENTRY_REPORT_URI?: string;
	STRIPE_PUBLISHABLE_KEY: string;
	TROON_IMAGE_HOST: string;
	TURNSTILE_SITE_KEY: string;
	ENVIRONMENT?: 'development' | 'staging' | 'production';
	WONDERPUSH_KEY?: string;
	NONCE: boolean;
};

declare global {
	interface Window {
		__ACCESS_CONFIG__: Config;
	}
}

export function getConfigValue<K extends keyof Config, T = Config[K]>(key: K, fallback?: T): T {
	return typeof window !== 'undefined' && window.__ACCESS_CONFIG__
		? (window.__ACCESS_CONFIG__[key] as T)
		: // @ts-expect-error TS still doesn't let you declare a symbol as an index
			globalThis[serverSym]
			? // @ts-expect-error TS still doesn't let you declare a symbol as an index
				globalThis[serverSym][key]
			: (fallback as T);
}

export function getConfig(type: 'client' | 'server'): Config {
	// @ts-expect-error TS still doesn't let you declare a symbol as an index
	return type === 'client' ? globalThis[clientSym] : globalThis[serverSym];
}
